/**
 * Feature Flags List Component
 */

import { FlagRow } from './FlagRow';
import { useI18n } from '@/i18n';
import type { FeatureFlag } from '@/types/featureFlags';

interface FlagListProps {
  flags: [string, FeatureFlag][];
  onToggle: (flagName: string, enabled: boolean, broadcastUpdate: boolean) => void;
  onEdit: (flagName: string) => void;
  onDelete: (flagName: string) => void;
  isToggling?: boolean;
}

export function FlagList({
  flags,
  onToggle,
  onEdit,
  onDelete,
  isToggling,
}: FlagListProps) {
  const { t } = useI18n();

  if (flags.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500">
        <p>{t('featureFlags.flagList.noFlags')}</p>
        <p className="text-sm mt-1">{t('featureFlags.flagList.noFlagsHint')}</p>
      </div>
    );
  }

  return (
    <div className="divide-y divide-gray-100">
      {flags.map(([name, config]) => (
        <FlagRow
          key={name}
          name={name}
          config={config}
          onToggle={onToggle}
          onEdit={onEdit}
          onDelete={onDelete}
          isToggling={isToggling}
        />
      ))}
    </div>
  );
}
